import { render, staticRenderFns } from "./DeleteCourseModal.vue?vue&type=template&id=0a433db2&"
import script from "./DeleteCourseModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCourseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports